var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinnerCrownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3598 16.84H4.53981C4.22631 16.84 3.96981 17.0965 3.96981 17.41V18.55C3.96981 18.8635 4.22631 19.12 4.53981 19.12H19.3598C19.6733 19.12 19.9298 18.8635 19.9298 18.55V17.41C19.9298 17.0965 19.6733 16.84 19.3598 16.84ZM21.6398 5.44004C20.6957 5.44004 19.9298 6.20597 19.9298 7.15004C19.9298 7.40297 19.9868 7.6381 20.0866 7.85541L17.5073 9.40154C16.9587 9.72929 16.2497 9.54404 15.9327 8.98829L13.0292 3.90816C13.4104 3.59466 13.6598 3.12441 13.6598 2.59004C13.6598 1.64597 12.8939 0.880035 11.9498 0.880035C11.0057 0.880035 10.2398 1.64597 10.2398 2.59004C10.2398 3.12441 10.4892 3.59466 10.8704 3.90816L7.96693 8.98829C7.64987 9.54404 6.93737 9.72929 6.39231 9.40154L3.81662 7.85541C3.9128 7.64166 3.97337 7.40297 3.97337 7.15004C3.97337 6.20597 3.20743 5.44004 2.26337 5.44004C1.3193 5.44004 0.549805 6.20597 0.549805 7.15004C0.549805 8.0941 1.31574 8.86004 2.2598 8.86004C2.35243 8.86004 2.44505 8.84579 2.53412 8.83154L5.10981 15.7H18.7898L21.3655 8.83154C21.4546 8.84579 21.5472 8.86004 21.6398 8.86004C22.5839 8.86004 23.3498 8.0941 23.3498 7.15004C23.3498 6.20597 22.5839 5.44004 21.6398 5.44004Z",
    fill: "#FFE206"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinnerCrownIcon);
export default __webpack_public_path__ + "static/media/winner-crown-icon.f1f8782e4259ffd008d00963d161f9e0.svg";
export { ForwardRef as ReactComponent };